export default "__VITE_ASSET__BHj_3DOL__"